import { useState, useEffect, useContext } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { noTecnicas } from "../../helpers/ImagesCache";
import CheckNoTecnicas from "../CheckNoTecnicas/CheckNoTecnicas";
import { TimelineContext } from "../../helpers/Context";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogNoTecnicas = ({
  callbackConfirm,
  callbackCancel,
  status,
  actionNoTecnicas,
  volverNoTecnicas,
  saveAnd,
  noBackground,
}) => {
  const T = useTranslation();
  const ctxTimeline = useContext(TimelineContext);
  const [isOpen, setIsOpen] = useState(status);
  const [canContinue, setCanContinue] = useState(false);

  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
    if (actionNoTecnicas) {
      actionNoTecnicas();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  const refreshContext = () => {
    const haveAnNull = ctxTimeline.nonTechnical.filter(
      (item) => item.selectedOption == null
    );
    if (haveAnNull.length == 0) {
      setCanContinue(true);
    } else {
      setCanContinue(false);
    }

    console.log(
      "%cContexto en Dialog no tecnicas Refresh context",
      "color:gray",
      ctxTimeline.nonTechnical
    );
  };

  return (
    <>
      <FloatingDialog
        isOpen={isOpen}
        onClose={handlerClose}
        noBackground={noBackground}
        variant="bottom"
      >
        <div className="w-full flex flex-col max-h-[80vh]">
          {/* Header */}
          <div className="flex flex-row items-center ml-8">
            <img src={noTecnicas} alt="" />
            <h4
              className={`${
                isTablet ? "text-2xl" : "text-l"
              } font-bold text-[#000e] p-4`}
            >
              {T("NoTecnicas[T1]")}
            </h4>
          </div>

          {/* Scrollable List */}
          <div className="flex-1 overflow-y-auto px-4">
            {ctxTimeline.nonTechnical.map((item, indx) => (
              <CheckNoTecnicas
                key={`check-no-tecnica-${indx}-item.title`}
                titulo={T(item.title)}
                desripcion={T(item.description)}
                object={item.object}
                options={item.options}
                selectedOption={item.selectedOption}
                onChange={refreshContext}
              />
            ))}
          </div>

          {/* Divider (optional) */}
          <div className="bg-[#DAD9DB] h-[1px]" />

          {/* Fixed Footer */}
          <div className="h-32 w-full flex justify-center items-center gap-2 bg-white shrink-0">
            <SimpleButton
              text={T("back")}
              onClick={volverNoTecnicas}
              variant="gray"
            />
            <SimpleButton
              text={T(isTablet ? saveAnd : "save")}
              onClick={handlerOnConfirm}
              disabled={!canContinue}
            />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogNoTecnicas;
